import { useGetForm } from "@/react/components/SettingsApp/Emails/components/Forms/hooks/useGetForm";
import type { FormEmbedDisplayFormat } from "@/react/types/Form";

import type { FormUsage, RenderType } from "./contexts/FormRenderingContext";
import { FormRenderingProvider } from "./contexts/FormRenderingContext";
import { FormContent } from "./FormContent";
import { useAdjustFormHeight } from "./hooks/useAdjustFormHeight";
import { ShowModal } from "./ShowModal";

interface FormRendererProps {
  embedDisplayFormat?: FormEmbedDisplayFormat;
  id: number;
  index: number;
  isPreview?: boolean;
  popupDelay?: number;
  popupFrequency?: number;
  renderType?: RenderType;
  usage?: FormUsage;
}
export const FormRenderer = ({
  id,
  index,
  isPreview = false,
  usage,
  embedDisplayFormat,
  popupFrequency,
  popupDelay,
  renderType = "embed",
}: FormRendererProps) => {
  const { data: form, isPending } = useGetForm({ id });
  const formDisplayFormat =
    usage === "page"
      ? "inline"
      : (embedDisplayFormat ?? form?.embed_display_format);
  const isModal = formDisplayFormat === "popup" && renderType === "embed";
  const RenderingComponent = isModal ? ShowModal : FormContent;

  useAdjustFormHeight({ form, index, isModal });

  if (isPending || !form) {
    return null;
  }

  return (
    <FormRenderingProvider
      form={form}
      index={index}
      isModal={isModal}
      isPreview={isPreview}
      usage={usage}
      popupDelay={popupDelay}
      popupFrequency={popupFrequency}
      renderType={renderType}
    >
      <RenderingComponent />
    </FormRenderingProvider>
  );
};
